// @ts-nocheck
import AppBar from '@material-ui/core/AppBar';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { BLUE, PERMISSION_ENTITIES, PERMISSIONS } from '../../_config/consts';
import { hasFormWritePermission } from '../../_config/utils';
import AbilityProvider from '../../permissionsUtils/AbilityProvider.js';
import ChartMultilineIconCustom from '../CustomIcons/ChartMultilineIconCustom.jsx';
import WearableIconCustom from '../CustomIcons/WearableIconCustom.jsx';
import AlarmIconCustom from '../CustomIcons/AlarmIconCustom.jsx';
import WearableForm from '../forms/WearableForm/WearableForm.jsx';
import MDButton from '../MDButton/MDButton.jsx';
import WearableTrackingHistoryView from './WearableTrackingHistoryView.jsx';
import WearableAlarmsDetailsView from './WearableAlarmsDetailsView.jsx';

const theme = createTheme({
  palette: {
    primary: { 500: BLUE },
  },
});

const wearableTypeOptions = [
  { label: 'wearableTypeSelect', value: '' },
  { label: 'wearableTypeBracelet', value: 'BLE_BRACELET' },
];

@connect((state) => ({
  wearable: state.wearables.selectedWearable,
  themeName: state.settings.items.theme.data.themeName,
  form: state.form.WearableForm,
}))
class WearableOperationalSection extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 0,
    };
  }

  onSelectTab(tabIndex) {
    this.setState({ selectedTab: tabIndex });
  }

  render() {
    const {
      dispatch,
      wearable,
      themeName,
      onSubmitWearableForm,
      onSelectGuest,
      onSelectAllowedAreas,
      onSelectNotAllowedAreas,
      form,
    } = this.props;
    const { selectedTab } = this.state;
    const canManageWearables = true //AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.ALL], PERMISSION_ENTITIES.WEARABLES_MANAGEMENT);
    const isNewWearable = !wearable || _.isEmpty(wearable) || !wearable.id;
    return (
        <div>
          {!isNewWearable && (
            <AppBar position="sticky" color="default">
              <Tabs
                value={selectedTab}
                textColor="primary"
                indicatorColor="primary"
                scrollable
                TabIndicatorProps={{
                  style: { display: 'none' }
                }}
                onChange={(e, index) => this.onSelectTab(index)}
              >
                <Tab 
                  icon={<WearableIconCustom style={{ width: 26 }} />} 
                  label={<h5 style={{ margin: 0, fontWeight: 'bold' }}><Entity entity="wearableData" /></h5>} 
                />
                <Tab 
                  icon={<ChartMultilineIconCustom style={{ width: 26 }} />} 
                  label={<h5 style={{ margin: 0, fontWeight: 'bold' }}><Entity entity="tracking" /></h5>} 
                />
                <Tab 
                  icon={<AlarmIconCustom style={{ width: 26 }} />} 
                  label={<h5 style={{ margin: 0, fontWeight: 'bold' }}><Entity entity="alarms" /></h5>} 
                />
              </Tabs>
            </AppBar>
          )}
          <div style={{ display: selectedTab === 0 ? 'block' : 'none', padding: 10, paddingBottom: '30%' }}>
            <WearableForm
              themeName={themeName}
              onSubmit={(wearableData) => onSubmitWearableForm(wearableData)}
              onSelectGuest={guest => onSelectGuest(guest)}
              onSelectAllowedAreas={areas => onSelectAllowedAreas(areas)}
              onSelectNotAllowedAreas={areas => onSelectNotAllowedAreas(areas)}
            />
            {canManageWearables ? (
              <MDButton
                title={<Entity entity="save" />}
                containerStyle={{ position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}
                style={{ height: 45, borderRadius: 0 }}
                onClick={() => dispatch(submit('WearableForm'))}
              />
            ) : null}
          </div>
          {!isNewWearable && (
            <div>
              <div style={{ display: selectedTab === 1 ? 'block' : 'none', padding: 20, paddingBottom: 100 }}>
                <WearableTrackingHistoryView wearable={wearable} />
              </div>
              <div style={{ display: selectedTab === 2 ? 'block' : 'none', padding: 20, paddingBottom: 100 }}>
                <WearableAlarmsDetailsView wearable={wearable} />
              </div>
            </div>
          )}
        </div>
    );
  }
}

export default WearableOperationalSection;
